import { nullToEmpty } from "@/js/utils";

export class VulFacilityStatusTranslator {
  static toPayload(editedItem) {
    return {
      fa_id: editedItem.fa_id,
      disaster_no: editedItem.disaster_no,
      eva_status: editedItem.eva_status,
      evacuee_vala: nullToEmpty(editedItem.evacuee_vala),
      evacuee_valb: nullToEmpty(editedItem.evacuee_valb),
      free_input: nullToEmpty(editedItem.free_input),
      delete_flg: "0",
      hash: editedItem.hash
    };
  }
}
